import m from './contact-channels191.js';

function i(n,a){var o=a.nationalNumber,r=a.defaultCountry,e=a.metadata,t=e.getCountryCodesForCallingCode(n);if(t)return t.length===1?t[0]:m(o,{countries:t,defaultCountry:r,metadata:e.metadata})}

export { i as default };
//# sourceMappingURL=contact-channels190.js.map
